if (!global._babelPolyfill) {
  require('babel-polyfill')
}

const { PRODUCTION, environment } = require('constants/environments')

const { h, render } = require('preact')

const { jsonParse } = require('helpers/utils')

const App = require('./App').default

const attributes = {
  config: 'data-widget-config',
  env: 'data-widget-env',
}

const getWidgets = (elements) =>
  [...elements].map((element) => {
    const config = jsonParse(element.getAttribute(attributes.config))
    const env =
      environment[element.getAttribute(attributes.env)] ||
      environment[PRODUCTION]

    return { config, env, element }
  })

const showOddsWidget = (elements) => {
  const widgets = getWidgets(elements)

  widgets.forEach(({ config, element, env }) =>
    render(<App config={config} environment={env} />, element),
  )
}

module.exports = showOddsWidget
